import React, {Component} from 'react';
import {Table, Modal, Image} from 'react-bootstrap';

import {appConfig} from '../../../config';
var dateFormat = require('dateformat');
class PatientInvoiceView extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const data =
      this.props.PatientInvoiceDtls && this.props.PatientInvoiceDtls.item
        ? this.props.PatientInvoiceDtls && this.props.PatientInvoiceDtls.item
        : null;

    return (
      <div>
        <div>
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="lg"
            backdrop="static"
          >
            <Modal.Header
              style={{fontSize: '35px', backgroundColor: '#f0f3f5'}}
              closeButton
            >
              <Modal.Title>
                <span style={{fontSize: '20px'}}>Patient Invoice Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                      <tr>
                        <td className="feedbkTdWdth">Reference Number</td>
                        <td className="storeModalCap">
                          {data !== null && data.invNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Order ID</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.orderId &&
                            data.orderId.orderNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Order Type</td>
                        <td className="storeModalCap">
                          {data !== null && data.orderType}
                        </td>
                      </tr>
                      <tr>
                        <td>Customer</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.vendorId &&
                            data.vendorId.fullName}
                        </td>
                      </tr>

                      <tr>
                        <td>Chemist</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.dstbtrDtls &&
                            data.dstbtrDtls.name}
                        </td>
                      </tr>
                      {/* <tr>
                        <td>Prescription Note</td>
                        <td className="storeModalCap">
                          {data !== null && data.prescpId&&data.prescpId.prscrptnTag}
                        </td>
                      </tr> 
                      
                      <tr>
                        <td>Invoice Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.amount}
                        </td>
                      </tr>*/}
                      <tr>
                        <td>Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.payableAmnt}
                        </td>
                      </tr>
                      <tr>
                        <td>Service Fee</td>
                        <td className="storeModalCap">
                          {data !== null && data.commsnAmnt}
                        </td>
                      </tr>
                      <tr>
                        <td>Tax Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.taxAmnt}
                        </td>
                      </tr>
                      <tr>
                        <td>Gateway Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.gatewayCharge}
                        </td>
                      </tr>
                      <tr>
                        <td>Chemist Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.amount}
                        </td>
                      </tr>
                      {/* <tr>
                        <td>Tax Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.taxAmnt}
                        </td>
                      </tr>
                      <tr>
                        <td>Commission Amount</td>
                        <td className="storeModalCap">
                          {data !== null && data.commissionAmnt}
                        </td>
                      </tr>
                      <tr>
                        <td>Voucher No.</td>
                        <td className="storeModalCap">
                          {data !== null && data.vouchrNo}
                        </td>
                      </tr>
                      <tr>
                        <td>Voucher Date</td>
                        <td className="storeModalCap">
                          {data !== null &&
                            data.vouchrDate != null &&
                            dateFormat(data.vouchrDate, "mediumDate")}
                        </td>
                      </tr> */}

                      <tr>
                        <td> Created Date</td>
                        <td className="feedbkModalCap">
                          {data !== null &&
                            data.createdAt !== null &&
                            dateFormat(data.createdAt, 'mediumDate')}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{backgroundColor: '#f0f3f5'}} />
          </Modal>
        </div>
      </div>
    );
  }
}

export default PatientInvoiceView;
